// NotFoundPage.jsx
import React from 'react';
// If you're using React Router, you might want to import Link for internal navigation:
// import { Link } from 'react-router-dom';

const NotFoundPage = () => {
	return (
		<div>
			{/* Main Content START */}
			<main className="py-5">
				<div className="container">
					<div className="h-100px d-none d-lg-block"></div>
					<div className="row align-items-center text-center py-sm-5">
						<div className="col-lg-8 mx-auto">
							{/* SVG Illustration START */}
							<figure className="m-0 pt-5 pt-md-0">
								<svg
									className="col-sm-7 col-lg-5"
									version="1.1"
									id="Layer_1"
									xmlns="http://www.w3.org/2000/svg"
									xmlnsXlink="http://www.w3.org/1999/xlink"
									x="0px"
									y="0px"
									viewBox="0 0 1285.3 712.4"
									style={{ enableBackground: 'new 0 0 1285.3 712.4' }}
									xmlSpace="preserve"
								>
									<style type="text/css">{`
                    .st0{opacity:0.2;fill:#0B2252;enable-background:new;}
                    .st1{fill:#DAEEFF;}
                    .st2{fill:#6AC1FF;}
                    .st3{fill:#3FB790;}
                    .st4{fill:#34916F;}
                    .st5{fill:#90DAD8;}
                    .st6{fill:#FFFFFF;}
                    .st7{fill:url(#SVGID_1_);}
                    .st8{fill:#14336D;}
                    .st9{fill:#FFAA9D;}
                    .st10{fill:url(#SVGID_00000080196097221175926860000015854635151939166352_);}
                    .st11{fill:url(#SVGID_00000125570478491118859570000016173875777852424844_);}
                    .st12{fill:url(#SVGID_00000139994743433262585760000002217132992610938001_);}
                    .st13{fill:url(#SVGID_00000103980266939832754290000005538789883632006285_);}
                  `}</style>
									{/* SVG content truncated for brevity */}
								</svg>
							</figure>
							{/* SVG Illustration END */}
							<h1 className="display-1 mt-4">404</h1>
							<h2 className="mb-2 h1">Page Not Found!</h2>
							<p>Either something went wrong or this page doesn't exist anymore.</p>
							{/* You can replace the anchor below with a Link if using React Router */}
							<a className="btn btn-primary-soft btn-sm" href="/">
								Go to home page
							</a>
						</div>
					</div>
					<div className="h-100px d-none d-lg-block"></div>
				</div>
			</main>
			{/* Main Content END */}

			{/* Footer START */}
			<footer className="bg-mode py-3">
				<div className="container">
					<div className="row">
						<div className="col-md-6">
							<ul className="nav justify-content-center justify-content-md-start lh-1">
								<li className="nav-item">
									<a className="nav-link" href="/">
										About
									</a>
								</li>
								<li className="nav-item">
									<a className="nav-link" target="_blank" rel="noopener noreferrer" href="/">
										Support
									</a>
								</li>
								<li className="nav-item">
									<a className="nav-link" target="_blank" rel="noopener noreferrer" href="/">
										Docs
									</a>
								</li>
								<li className="nav-item">
									<a className="nav-link" href="/">
										Privacy &amp; terms
									</a>
								</li>
							</ul>
						</div>
						<div className="col-md-6">
							<p className="text-center text-lg-end mb-0">©{new Date().getFullYear()}<a className="text-body" target="_blank" href="/" rel="noreferrer">  Lemont Rec Leagues </a>All rights reserved.</p>
						</div>
					</div>
				</div>
			</footer>
			{/* Footer END */}
		</div>
	);
};

export default NotFoundPage;
